import React, { Component } from "react";
import "./ExpandCommand.css";

const ExpandCommand = (props) => {
  
  return (
    <svg
      name="expandCommand"
      className={props.isShow ? "expand" : "isClose"}
      //onClick={props.click}
      style={{ stroke: props.color }}
    >
      <rect
        x="9"
        y="-4"
        width="8.5"
        height="1.5"
        rx="1"
        transform="rotate(45)"
      />
      <rect
        x="-5"
        y="16"
        width="8.5"
        height="1.5"
        rx="1"
        transform="rotate(-45)"
      />
    </svg>
  );
};

export default ExpandCommand;
